const lan = {
  REDIRECT: "Chuyển hướng...",
  RULE: {
    SERVICE_TYPE: "Vui lòng chọn Loại dịch vụ",
    COUNTRY: "Vui lòng chọn quốc gia hoặc khu vực của bạn",
    USERNAME: "Yêu cầu phải có tên người dùng",
    EMAIL: "Yêu cầu phải có email",
    EMAIL2: "Vui lòng nhập đúng tài khoản email.",
    PRODUCT: "Vui lòng chọn sản phẩm của bạn",
    PRODUCTSN: "Vui lòng nhập số sê-ri sản phẩm của bạn",
    PRODUCTSN_LEN: "Vui lòng nhập từ 12 đến 15 chữ cái hoặc chữ số",
    BIRTHDAY: "Yêu cầu phải có ngày sinh",
    REQUIRED: "Yêu cầu",
  },
  SYS: {
    HEAD: "Hệ thống",
    NOSERVICE:
      "Rất tiếc, ASUS Chat cho quốc gia hoặc khu vực bạn đã chọn không khả dụng.",
    CHECK_FILESIZE:
      "Hãy kiểm tra kích thước của hình ảnh hoặc tệp đính kèm. Giới hạn:",
    RECONNECTED: "Trạng thái kết nối đã trở lại bình thường",
    UNABLE_SEND: "Không thể gửi các tập tin đính kèm",
    NO_NETWORK: "Không có kết nối Internet",
    NO_NETWORK_INFO:
      "Không có kết nối Internet. Vui lòng kết nối với Internet và thử lại.",
  },
  IDLE: {
    HEAD:
      "Bạn đã tạm dừng hoạt động trong một thời gian. Bạn có muốn tiếp tục cuộc hội thoại?",
    BUTTON: "Tiếp tục",
  },
  DISCONNECT: {
    HEAD: "Cuộc hội thoại đã kết thúc",
    BUTTON: "Kết thúc",
  },
  LAYOUT: {
    STEP_1: "Chọn sản phẩm",
    STEP_2: "Điều khoản phục vụ",
    STEP_3: "Đăng nhập",
    STEP_4: "Thông tin",
    SELECT_SKILL: "Chọn sản phẩm",
    PREV_STEP: "Quay lại",
    NEXT_STEP: "Tiếp theo",
    NOTSET: "Chưa thiết lập",
    AGREEN: "Đồng ý",
    NOTAGREEN: "Không đồng ý",
    LEAVE: "Rời khỏi",
    TYPE_HERE: "Gõ vào đây",
    CHAT_DOWNLOAD:
      "Vui lòng nhấp vào đây để lưu lại nội dung Chat của bạn với Dịch vụ khách hàng trực tuyến ASUS.",
  },
  COUNTRY: {
    SELECT_COUNTRY: "Vui lòng chọn quốc gia hoặc khu vực Dịch vụ của bạn",
  },
  POLICY: {
    PRIVACY: "Chính sách bảo vệ quyền riêng tư",
    SAT_SURVEY: "Thỏa thuận dịch vụ",
    CONFIRM_COUNTRY: {
      H1: "Kính chào Quý khách hàng",
      P1:
        "Bạn hiện đang truy cập Dịch vụ khách hàng trực tuyến ASUS cho Việt Nam, dịch vụ khác với khu vực hiện tại của bạn. Theo Điều khoản bảo hành của ASUS, không phải mọi sản phẩm ASUS đều được áp dụng cho dịch vụ Hỗ trợ và Bảo hành Quốc tế. Nếu trang Web khu vực mà bạn đang truy cập ở trên không phải là khu vực của bạn mua sản phẩm ASUS hoặc khác với khu vực hiện tại của bạn, điều đó có thể ảnh hưởng đến quyền lợi của bạn. Bạn có thể tiếp tục sử dụng Dịch vụ khách hàng trực tuyến ASUS cho Việt Nam hoặc thay đổi Dịch vụ khách hàng trực tuyến ASUS cho khu vực của bạn.",
      P2: "",
      P3: "",
      B1: "Chuyển sang ASUS",
      B2: "Website",
      B3: "Tiếp tục sử dụng",
    },
    BULLETIN: {
      HEAD: "Thông báo về một tin nhắn quan trọng",
      CONFIRM: "Tôi đã hiểu",
    },
  },
  SURVEY: {
    SURVEY_ENTER: "Vui lòng điền thông tin liên hệ của bạn",
    SURVEY_TYPE: "Vui lòng chọn loại hình dịch vụ",
    PROBLEM_BRIEF: "Bạn sẽ mô tả vấn đề của mình như thế nào?",
    TYPE1: "Câu hỏi chung",
    TYPE2: "Yêu cầu sửa chữa",
    TYPE3: "Hỗ trợ kĩ thuật",
    TYPE4: "Yêu cầu bảo hành",
    TYPE5: "Ý kiến và phản hồi",
    EC_TYPE1: "Thông tin Sản phẩm và Bán hàng",
    EC_TYPE2: "Sự kiện Marketing",
    EC_TYPE3: "Tình trạng giao hàng và đơn hàng",
    EC_TYPE4: "Dịch vụ hoàn trả",
    SIGNUPDATA: "Thông tin đăng ký của bạn",
    NAME: "Tên",
    TEL: "Số điện thoại",
    ORDER_NO: "Order No.",
    BIRTHDAY: "Ngày sinh",
    LABEL_EMAIL: "Email",
    EMAIL: "Email",
    DEVICEINFO: "Thông tin sản phẩm",
    DEVICENAME: "Tên sản phẩm",
    MY_DEVICE: "Sản phẩm của bạn",
    MY_DEVICE_SELECT: "Chọn sản phẩm của bạn",
    MY_DEVICE_EMPTY: "Bạn chưa có thiết bị nào.",
    LABEL_DEVICESN: "Số Sê-ri",
    DEVICESN: "Sê-ri sản phẩm",
    DEVICESN_ERROR: "Số serial bạn nhập không hợp lệ.",
    PREPARE: "Tạo phòng Chat, sẵn sàng Chat",
    START: "Bắt đầu Chat",
    AGE_LIMIT: "Giới hạn tuổi",
    AGE_LIMIT_DESC: "Bạn không đáp ứng yêu cầu về độ tuổi để sử dụng ASUS Chat",
    REPEAT_ENTRY: {
      H1: "Đã phát hiện phòng Chat hiện có",
      P1:
        "Bạn có chắc chắn muốn bắt đầu một cuộc trò chuyện mới không? Khi một cuộc trò chuyện mới được mở, cuộc trò chuyện cũ sẽ kết thúc.",
      B0: "Xác nhận",
      B1: "Hủy",
    },
  },
  CONNECTTING: {
    P1: "Vui lòng đợi trong giây lát và không đóng cửa sổ Chat",
    P2: "ASUS Chat đang kết nối bạn với nhân viên chăm sóc khách hàng",
    NOTE: "Gợi ý",
    BEFORE_LEAVE:
      "Bạn có chắc chắn muốn chấm dứt cuộc trò chuyện của bạn không?",
    B0: "Rời khỏi",
    B1: "Ở lại và chờ phản hồi",
  },
  OFFLIEN: {
    OTHER_CONTACT: "Liên hệ với ASUS qua các kênh khác",
    MAIL: "Hộp thư chăm sóc khách hàng",
    TEL: "Đường dây nóng - Hotline",
    CLOSE: "Đóng",
  },
  WAITTING: {
    WATTING_NUM: "Vị trí trong hàng đợi",
    PEOPLE: "Khách hàng",
    NOTE: "Gợi ý",
    BEFORE_LEAVEL: "Bạn có chắc chắn muốn thoát khỏi hàng đợi không?",
    LEAVE_DESC:
      "Nếu bạn không muốn xếp hàng đợi, bạn có thể kết thúc cuộc hội thoại",
    LEAVE: "Kết thúc cuộc trò chuyện",
    STAY: "Ở lại và chờ kết nối",
  },
  CHATROOM: {
    TYPING: "Nhân viên đang đánh máy...",
    HEAD: {
      CLOSE_AMD_SURVEY: "Kết thúc cuộc hội thoại",
      TERMINATE: "Kết thúc cuộc hội thoại",
    },
    FOOTER: { CHAT_FINISH: "Cuộc hội thoại đã kết thúc" },
    FINISH:
      "Hội thoại đã kết thúc, bạn có cần hỗ trợ hoặc tìm hiểu các dịch vụ khác không?",
    SAT_SURVEY: {
      SAT: "Hài lòng",
      DISSAT: "Không hài lòng",
      SAT_CHOOSE: "Những loại dịch vụ nào? (nhiều)",
      HEAD: "Bạn có hài lòng với dịch vụ Chat trực tuyến của ASUS không?",
      DESC:
        "Lắng nghe phản hồi của bạn là động lực để chúng tôi không ngừng cải thiện. Xin vui lòng cho chúng tôi biết nếu bạn có bất kỳ đề xuất nào về Dịch vụ hoặc Hỗ trợ của ASUS.",
      OTHER_OPTION: "Khác",
      OTHER_REASON: "Vui lòng điền vào các lý do khác",
      SEND: "Gửi",
    },
    CLOSE: {
      TITLE: "Bạn có chắc chắn muốn kết thúc dịch vụ Chat không?",
      P1:
        'Nhấp vào "Kết thúc" để đóng cửa sổ. Nếu bạn cần sử dụng lại Chat lần nữa, vui lòng nhấp vào "Bắt đầu trò chuyện mới".',
      B0: "Kết thúc",
      B1: "Hủy",
    },
  },
  ERROR: {
    H1: "Phòng trò chuyện không tồn tại hoặc cuộc hội thoại đã kết thúc",
    CLOSE: "Đóng cửa sổ",
  },
  CHAT_END: {
    H1: "Cảm ơn bạn rất nhiều. Cuộc hội thoại đã kết thúc",
    CLOSE: "Đóng cửa sổ",
  },
  CHAT_CLOSE: {
    H1:
      "Do kết nối của bạn đã ngừng hoạt động hơn 300 giây nên hệ thống đã kết thúc cuộc hội thoại này.",
    DESC:
      "Nếu bạn đang sử dụng mạng không dây hoặc mạng di động, vui lòng di chuyển đến vị trí có tín hiệu mạnh hơn; hoặc chuyển sang kết nối mạng có dây. Chúng tôi xin lỗi vì sự bất tiện này",
    CLOSE: "Đóng cửa sổ",
  },
  SURVEY_DONE: {
    H1: "Cảm ơn bạn. Bạn đã hoàn thành khảo sát Sự hài lòng về Dịch vụ",
    P1:
      'Cảm ơn bạn đã dành thời gian để hoàn thành Khảo sát sự hài lòng về Dịch vụ. Phản hồi của bạn là động lực giúp chúng tôi không ngừng cải thiện chất lượng dịch vụ. Nếu bạn cần hỗ trợ hoặc tìm hiểu thêm về Dịch vụ, vui lòng nhấp vào "Bắt đầu cuộc trò chuyện mới". Xin vui lòng nhấp vào "Đóng cửa sổ" để kết thúc trò chuyện nếu chúng tôi đã giải đáp xong yêu cầu của bạn',
    AGAIN: "Bắt đầu cuộc trò chuyện mới",
    CLOSE: "Đóng cửa sổ",
    YT_H1: "Khám phá các mẹo và bí quyết công nghệ qua video hỗ trợ của ASUS.",
    YT_H2: "Nhấp để khám phá!",
  },
  AGENT_OFFLINE: {
    H1:
      "Kết nối Internet của nhân viên chăm sóc khách hàng đang không có phản hồi; cuộc trò chuyện của bạn hiện đang bị gián đoạn",
    H2:
      "Vui lòng không đóng cửa sổ; chúng tôi đang nỗ lực để tiếp tục trò chuyện",
    DESC:
      'Bạn cũng có thể chọn kết thúc trò chuyện và bắt đầu Khảo sát hoặc nhấp vào "Bắt đầu trò chuyện mới", chúng tôi sẽ ngay lập tức chỉ định một nhân viên mới để tiếp tục cuộc Trò chuyện của bạn. Chúng tôi xin lỗi vì sự bất tiện này',
    AGAIN: "Bắt đầu cuộc trò chuyện mới",
  },
  VIDEOCALL: {
    MEDIA_NOTALLOW: "Không thể sử dụng camera và micrô",
    H1: "Bạn đã sẵn sàng tham gia chưa?",
    P1:
      "Để nhân viên dịch vụ khách hàng ASUS có thể giúp bạn giải quyết vấn đề hiệu quả hơn, bạn phải cho phép thiết bị truy cập vào camera và micrô của mình để tham gia phòng trò chuyện video và vui lòng đảm bảo rằng kết nối mạng di động của bạn ổn định và hoạt động bình thường",
    P2:
      "Sau khi truy cập, bạn vẫn có thể thoải mái thiết lập nút chuyển ống kính và tắt tiếng micro.",
    VIDEO_STATE: "Trạng thái video",
    VIDEO_ON: "Bật",
    VIDEO_OFF: "Tắt",
    AUDIO_STATE: "Trạng thái âm thanh",
    AUDIO_ON: "Bật",
    AUDIO_OFF: "Tắt",
    ENTER: "Tham gia",
    HANGUP: {
      H1: "Ngắt cuộc trò chuyện",
      P1: "Bạn có chắc chắn muốn ngắt cuộc trò chuyện video không??",
      CONFIRM: "Xác nhận",
      CANCEL: "Huỷ",
    },
    END: {
      H1: "Cuộc gọi video đã kết thúc",
      P1:
        "Cảm ơn bạn, cuộc trò chuyện video này đã kết thúc, bạn có thể đóng cửa sổ này.",
    },
  },
  GPT: {
    LAYOUT: {
      STEP_1: "Chọn sản phẩm",
      STEP_2: "Điều khoản phục vụ",
      STEP_3: "Đăng nhập",
      STEP_4: "Thông tin",
      SELECT_SKILL: "Chọn sản phẩm",
      WELCOME: "Chào mừng",
      AGREE: "Đồng ý",
      START: "Bắt đầu",
      CANCEL: "Hủy",
      WAIT: "Vui lòng đợi",
      INPUT: "Nhập ký tự",
      TRANSFER_TOAGENT: "Chuyển đến nhân viên hỗ trợ.",
      READMORE: "Tìm hiểu thêm",
      COLLAPSE: "Ẩn",
      INPUT_SN: "Vui lòng nhập lại số serial",
      YOU_MAY_ALSO: "Bạn cũng có thể muốn hỏi:",
      FOR_FURTHER: "Để biết thêm thông tin, vui lòng tham khảo:",
      RECORDING: "Bắt đầu nói",
      RECORDING_NOT_SUPPORTED:
        "Trình duyệt của bạn không hỗ trợ nhận dạng giọng nói",
      RECORDING_NOT_FOUND:
        "Không tìm thấy thiết bị ghi âm. Vui lòng kiểm tra lại micrô và quyền của bạn.",
    },
    IS_COMPONENT_SN:
      "Đầu vào là số sê-ri của linh kiện, bạn phải nhập chính xác số sê-ri của máy.",
    WARRANTY: {
      SERIES: "Loại sản phẩm",
      MODEL: "Tên sản phẩm",
      SERIALNO: "Số serial sản phẩm",
      STATUS: "Tình trạng bảo hành",
      DATE: "Ngày hết hạn bảo hành",
    },
    HEAD: {
      LEAVE: "Rời khỏi",
      CREATE_NEW: "Tạo phòng chat mới",
    },
    ENTRANCE: {
      POLICY: "Chính sách bảo mật",
      AGREE: "Nhấn Đồng ý để bắt đầu hội thoại",
    },
    MESSAGE: {
      WAIT:
        "Vui lòng đợi trong giây lát, chúng tôi đang tìm giải pháp cho bạn.",
    },
    END: "Cuộc trò chuyện đã kết thúc",
    END_MSG: "Chúng tôi rất vui được phục vụ bạn. Cuộc trò chuyện đã kết thúc.",
    END_SURVEY: "Khảo sát mức độ hài lòng",
    END_SURVEY_MSG:
      "Chúng tôi rất vui được phục vụ bạn. Cuộc trò chuyện đã kết thúc.",
    BACKHOME: "Quay lại trang chủ",
    SURVEY: {
      DESC: "Vui lòng đánh giá trải nghiệm của bạn với trợ lý ảo ASUS.",
      SAT: "Hài lòng",
      DISSAT: "Không hài lòng",
      FEEDBACK: "Vui lòng gửi cho chúng tôi phản hồi của bạn.",
      SEND: "Gửi",
      BACK: "Hủy",
    },
    SURVEY_DISLIKE: {
      H1: "Điều gì khiến bạn không hài lòng với câu trả lời?",
      P: "Phản hồi của bạn giúp chúng tôi nâng cao chất lượng dịch vụ.",
      BUTTON: "Gửi",
    },
    HISTORY: {
      TITLE: "Lịch sử hội thoại ",
      AGO: "{giờ} giờ trước",
      CONTINUE: "Tiếp tục hội thoại",
      CLOSE: "Cuộc trò chuyện đã kết thúc.",
      RESTART: "Khởi động lại với Trợ lý ảo",
      NON_SERVICE: "Ngoài giờ phục vụ",
      VIEW_HISTORY: "Nhấp để xem lịch sử trò chuyện mới nhất.",
    },
  },
};
export default lan;
